/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiScreeningAlertFilterExpression } from './ApiScreeningAlertFilterExpression';
import {
    ApiScreeningAlertFilterExpressionFromJSON,
    ApiScreeningAlertFilterExpressionFromJSONTyped,
    ApiScreeningAlertFilterExpressionToJSON,
    ApiScreeningAlertFilterExpressionToJSONTyped,
} from './ApiScreeningAlertFilterExpression';
import type { ApiUser } from './ApiUser';
import {
    ApiUserFromJSON,
    ApiUserFromJSONTyped,
    ApiUserToJSON,
    ApiUserToJSONTyped,
} from './ApiUser';

/**
 * Set of expressions that defines screening alerts search filters with its metadata
 * @export
 * @interface ApiScreeningAlertFilter
 */
export interface ApiScreeningAlertFilter {
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningAlertFilter
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningAlertFilter
     */
    name: string;
    /**
     * 
     * @type {Array<ApiScreeningAlertFilterExpression>}
     * @memberof ApiScreeningAlertFilter
     */
    expressions: Array<ApiScreeningAlertFilterExpression>;
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningAlertFilter
     */
    inSync: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningAlertFilter
     */
    alertCount?: number;
    /**
     * 
     * @type {ApiUser}
     * @memberof ApiScreeningAlertFilter
     */
    createdBy: ApiUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningAlertFilter
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningAlertFilter
     */
    updatedTime?: Date;
}

/**
 * Check if a given object implements the ApiScreeningAlertFilter interface.
 */
export function instanceOfApiScreeningAlertFilter(value: object): value is ApiScreeningAlertFilter {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expressions' in value) || value['expressions'] === undefined) return false;
    if (!('inSync' in value) || value['inSync'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function ApiScreeningAlertFilterFromJSON(json: any): ApiScreeningAlertFilter {
    return ApiScreeningAlertFilterFromJSONTyped(json, false);
}

export function ApiScreeningAlertFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningAlertFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'expressions': ((json['expressions'] as Array<any>).map(ApiScreeningAlertFilterExpressionFromJSON)),
        'inSync': json['inSync'],
        'alertCount': json['alertCount'] == null ? undefined : json['alertCount'],
        'createdBy': ApiUserFromJSON(json['createdBy']),
        'createdTime': (new Date(json['createdTime'])),
        'updatedTime': json['updatedTime'] == null ? undefined : (new Date(json['updatedTime'])),
    };
}

export function ApiScreeningAlertFilterToJSON(json: any): ApiScreeningAlertFilter {
    return ApiScreeningAlertFilterToJSONTyped(json, false);
}

export function ApiScreeningAlertFilterToJSONTyped(value?: ApiScreeningAlertFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'expressions': ((value['expressions'] as Array<any>).map(ApiScreeningAlertFilterExpressionToJSON)),
        'inSync': value['inSync'],
        'alertCount': value['alertCount'],
        'createdBy': ApiUserToJSON(value['createdBy']),
        'createdTime': value['createdTime'].toISOString(),
        'updatedTime': value['updatedTime'] == null ? value['updatedTime'] : value['updatedTime'].toISOString(),
    };
}

